import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { searchNetworkOrdersAccountLevel } from "./redux/networkorder.actions";
import { FullNetworkOrders } from "./redux/networkorder.selectors";


export const hasPurchasedProduct = (products, orders) => {

    if (!products || products?.length === 0) return true; // NO RESTRICTIONS
    if (!orders) return false; // You haven't purchased anything.

    // Clean Array
    const easyProducts = products.map(p => p.productId);

    // Look Through your Orders
    let status = false;
    const c = orders.map(o => {
        if (o?.meta?.stripe?.payment_status === 'paid') {
            let s = false;
            const d = o?.product?.map(nP => {

                if (easyProducts.includes(nP.id)) {
                    status = true;
                }
            })

        }
    })

    return status;
}

export const useNetworkProductPurchased = () => {

    const dispatch = useDispatch();
    const storeOrders = FullNetworkOrders();
    const [hasAccess, setHasAccess] = useState(false);
    const [products, setProducts] = useState([]);

    useEffect(() => { dispatch(searchNetworkOrdersAccountLevel(1, 9999, null)) }, []);
    useEffect(() => {
        if (!products || products?.length === 0) {
            setHasAccess(true); // No Restrictions
            return;
        } else if (products?.length > 0 && storeOrders?.items?.rows?.length <= 0) {
            setHasAccess(false); // There are Product Restrictions but you haven't purchased anything.
        } else if (products?.length > 0 && storeOrders?.items?.rows?.length > 0) {
            const check = hasPurchasedProduct(products, storeOrders?.items?.rows);
            setHasAccess(check); // Check the restirctions against the purchases.
        } else {
            setHasAccess(false); // Default to NO ACCESS
        }

    }, [products, storeOrders])
    return {
        hasAccess,
        products,
        setProducts
    }

}